class SearchCollection extends HTMLElement {
  constructor() {
    super();

    this.expandButtons = this.querySelectorAll(".search-collection__expand");

    this.expandButtons.forEach((button) => {
      button.addEventListener("click", () => {
        this.handleClick(button);
      });
    });
  }

  handleClick(button) {
    const content = this.querySelector(".search-collection__content");
    const nextButton = this.querySelector(".search-collection__expand.hidden");

    if (!content || !nextButton) return;

    content.classList.toggle("collapsed");
    button.classList.add("hidden");
    nextButton.classList.remove("hidden");

    button.setAttribute("tabindex", "-1");
    nextButton.setAttribute("tabindex", "0");

    button.setAttribute(
      "aria-expanded",
      String(!content.classList.contains("collapsed")),
    );
    nextButton.setAttribute(
      "aria-expanded",
      String(!content.classList.contains("collapsed")),
    );
  }
}

if (!customElements.get("search-collection")) {
  customElements.define("search-collection", SearchCollection);
}
